'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Content$State(mealoramaState) {
  this.fg = null;
  this.fg = mealoramaState;
}
export { $c_Lmealorama_Content$State as $c_Lmealorama_Content$State };
$p = $c_Lmealorama_Content$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Content$State;
/** @constructor */
function $h_Lmealorama_Content$State() {
}
export { $h_Lmealorama_Content$State as $h_Lmealorama_Content$State };
$h_Lmealorama_Content$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 382765188, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Content$State)) {
    var x = this.fg;
    var x$2 = x$0.fg;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.fg;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_Content$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jq)));
}
export { $isArrayOf_Lmealorama_Content$State as $isArrayOf_Lmealorama_Content$State };
var $d_Lmealorama_Content$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Content$State, "mealorama.Content$State", ({
  jq: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Content$State as $d_Lmealorama_Content$State };
//# sourceMappingURL=mealorama.-Content$-State.js.map
